export default "<div id=\"{{id}}\" class=\"video\"></div>\r\n"